import {createStore} from 'vuex'
import menu from './modules/menu'
import product from './modules/product'
import layout from './modules/layout'
import chat from './modules/chat'
import common from './modules/common'
import contact from './modules/contact'
import jobs from './modules/jobs'
import courses from './modules/courses'
import support from './modules/support'
import todo from './modules/todo'
import table from './modules/table'
import bootstrap from "./modules/bootstrap"
import tags from "./modules/tags"
import language from "./modules/language"
export default createStore({
    state:{},
    getters:{
     
    },
    mutations: {
        
      },
      actions: {
        
      },
    modules:{
        menu,todo,table, language,
        layout,product,chat,common,contact,jobs,courses,support,bootstrap,tags
    },
  
})